const action = 'ORGANIZATIONS_DETAIL';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { orgId, includeSso }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: { org, ssoRequested, sso: { sso, redirect_uri } | null }
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
